import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { JOURNAL } from "../data/content";
import { MaskedLines, Reveal } from "../components/Motion";
import { CtaBand } from "../components/Cta";

export default function Journal() {
  return (
    <>
      <section className="page-hero simple" data-testid="journal-hero">
        <div className="ph-content">
          <p className="crumb">
            <Link to="/">Home</Link> <span>/</span> Journal
          </p>
          <h1>
            <MaskedLines lines={[<>Notes from</>, <em key="v">the void.</em>]} delay={0.2} />
          </h1>
          <p className="ph-intro">
            Essays and behind-the-scenes notes from the studio — on film, identity, product and the craft of holding
            attention.
          </p>
        </div>
      </section>

      <section className="journal-index section-pad" data-testid="journal-index">
        {JOURNAL.map((article, i) => (
          <Reveal key={article.slug} delay={i * 0.06}>
            <Link to={`/journal/${article.slug}`} className="journal-row" data-testid={`journal-${article.slug}`}>
              <div className="jr-image">
                <img src={article.image} alt={article.title} loading="lazy" />
              </div>
              <div className="jr-body">
                <p className="jr-meta">
                  <span>{article.tag}</span> · {article.date} · {article.readTime}
                </p>
                <h3>{article.title}</h3>
                <p className="jr-excerpt">{article.excerpt}</p>
              </div>
              <ArrowUpRight size={22} />
            </Link>
          </Reveal>
        ))}
      </section>

      <CtaBand testid="journal-cta-band" />
    </>
  );
}
